/**
 *  Return default state for setup stored
 * @returns { object} Default state object
 */
export function getDefaultState() {
  return {
    linkDefaultViewType: null
  };
}

const state = getDefaultState();

export default state;
